'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var serialize = function serialize(_ref) {
  var id = _ref.id,
      type = _ref.type,
      attributes = _ref.attributes;
  return Object.assign({}, {
    id: id,
    type: type
  }, attributes);
};

var itemSerializer = function itemSerializer(_ref2) {
  var id = _ref2.id,
      type = _ref2.type,
      attributes = _ref2.attributes;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var d = Object.assign({}, {
    id: id,
    type: type
  }, attributes);
  if (Object.prototype.hasOwnProperty.call(d, 'widget')) d.widget = d.widget.map(serialize);
  if (Object.prototype.hasOwnProperty.call(d, 'layer')) d.layer = d.layer.map(serialize);

  if (Object.prototype.hasOwnProperty.call(d, 'metadata')) {
    d.metadata = d.metadata.map(serialize);

    if (options.locale) {
      d.metadata = d.metadata.find(function (m) {
        return m.language === options.locale;
      }) || {};
    }
  }

  if (Object.prototype.hasOwnProperty.call(d, 'vocabulary')) d.vocabulary = d.vocabulary.map(serialize);

  if (Object.prototype.hasOwnProperty.call(d, 'legendConfig') && Object.prototype.hasOwnProperty.call(d.legendConfig, 'items')) {
    d.legendConfig.items = d.legendConfig.items.map(function (item, index) {
      var i = Object.assign({}, item);
      i.id = i.id || index;
      return i;
    });
  }

  return d;
};

var wriAPISerializer = exports.wriAPISerializer = function wriAPISerializer(_ref3) {
  var data = _ref3.data;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (data && Array.isArray(data)) return data.map(function (d) {
    return itemSerializer(d, options);
  });
  return itemSerializer(data, options);
};

exports.default = wriAPISerializer;